import React, { useState } from 'react';
import styles from './styles.module.scss';

interface IProps {
    value: string | null;
    onChange: (value: string | null) => void;
}

type TMode = 'select' | 'number';

const NUMBER_MODE_DEFAULT = '2';

const BackIcon: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M9 3.5L5 7L9 10.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const deriveMode = (value: string | null): TMode => {
    const num = value === null ? NaN : Number(value);
    return !isNaN(num) && num > 1 ? 'number' : 'select';
};

const ShortValueField: React.FC<IProps> = ({ value, onChange }) => {
    const [mode, setMode] = useState<TMode>(() => deriveMode(value));

    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const raw = e.currentTarget.value;
        if (raw === 'number') {
            setMode('number');
            onChange(NUMBER_MODE_DEFAULT);
            return;
        }
        onChange(raw === 'n/a' ? null : raw);
    };

    const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.currentTarget.value === '' ? null : e.currentTarget.value);
    };

    const step = (delta: number) => {
        const current = value === null ? NaN : Number(value);
        const next = Math.max(0, (isNaN(current) ? 0 : current) + delta);
        onChange(String(next));
    };

    const switchToSelect = () => {
        setMode('select');
        const current = value === null ? NaN : Number(value);
        onChange(!isNaN(current) && current <= 1 ? String(current) : '0');
    };

    if (mode === 'number') {
        return (
            <div className={styles.shortField__numberGroup}>
                <button
                    type="button"
                    className={styles.shortField__stepperBtn}
                    onClick={() => step(-1)}
                >
                    −
                </button>
                <input
                    type="number"
                    min={0}
                    className={styles.shortField__numberInput}
                    value={value ?? ''}
                    onChange={handleNumberChange}
                />
                <button
                    type="button"
                    className={styles.shortField__stepperBtn}
                    onClick={() => step(1)}
                >
                    +
                </button>
                <button
                    type="button"
                    className={styles.shortField__backBtn}
                    title="Повернутись до Так/Ні/N/A"
                    onClick={switchToSelect}
                >
                    <BackIcon />
                </button>
            </div>
        );
    }

    return (
        <select
            className={styles.shortField__select}
            value={value ?? 'n/a'}
            onChange={handleSelectChange}
        >
            <option value="0">NO</option>
            <option value="1">YES</option>
            <option value="n/a">N/A</option>
            <option value="number">NUMBER</option>
        </select>
    );
};

export default ShortValueField;
